/**
 * Deep merge utility function to replace lodash.merge
 * @param target - The target object to merge into
 * @param sources - Source objects to merge from
 * @returns Merged object
 */
export function deepMerge(target: Record<string, unknown>, ...sources: Record<string, unknown>[]): Record<string, unknown> {
  if (!sources.length) return { ...target };
  
  const source = sources.shift();
  
  if (source === undefined) return { ...target };
  
  const result = { ...target };
  
  if (isObject(result) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!result[key]) {
          result[key] = { ...(source[key] as Record<string, unknown>) };
        } else {
          result[key] = deepMerge(result[key] as Record<string, unknown>, source[key] as Record<string, unknown>);
        }
      } else {
        result[key] = source[key];
      }
    }
  }
  
  return deepMerge(result, ...sources);
}

/**
 * Check if value is an object (but not null, array, or primitive)
 */
function isObject(item: unknown): item is Record<string, unknown> {
  return item !== null && typeof item === 'object' && !Array.isArray(item);
} 